exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-danger[data-v-359044d2]{color:#b1093e;font-weight:700}", ""]);

// exports
